<template>
  <div class="fill-height of-y d-flex align-center mr-2" >
    <div class="ml-4 text-h5 font-weight-light">Employees</div>
    <div class="flex-grow-1">
      <slot></slot>
    </div>

    <v-btn
      color="primary"
      class="mx-2"
      small
      outlined
      @click="$store.state.ref.employees.showAdd = true"
    >Add Employee</v-btn>

    <v-btn
      color="primary"
      class="mx-2"
      small
      outlined
      @click="showImportEmployees = !showImportEmployees"
    >Import Employees</v-btn>

    <div style="width: 300px">
      <v-text-field
        placeholder="Search"
        hide-details
        class="pa-0 ma-0 mx-2"
        color="primary"
        prepend-inner-icon="mdi-magnify"
        solo
        dense
        v-model="$store.state.ref.employees.filterStr"
      ></v-text-field>
    </div>
    <app-employee-import
      v-if="showImportEmployees"
      :shown.sync="showImportEmployees"
    ></app-employee-import>
    
    <v-btn
        icon
        color="primary"
        class="mx-2"
        small
        @click="downloadSummary"
    >
      <v-icon>mdi-microsoft-excel</v-icon>
    </v-btn>
  </div>
</template>

<script>
import AppEmployeeImport from "@/components/Employees/AppEmployeeImport";
import xls from "json-as-xlsx";
export default {
  components: {
    AppEmployeeImport

  },
  props: {
    shown: Boolean
  },
  data() {
    return {
      showImportEmployees: false
    }
  },
  watch: {

  },
  methods: {
    downloadSummary() {
      
      
      const employeeData = []
      
      for (const v of this.$store.state.employees) {
        const obj = {
          employee: v.name || '',
          employeeNumber: v.employeeNumber || '',
          employeeStatus: v.disabled ? 'Disabled' : 'Enabled',
          team: this.$store.getters.teamMap.get(v.teamId)?.name || '',
        }
        
        const devices = this.$store.state.devices.filter(d => d.employeeId === v._id && !d.userDevice)
        
        if (!devices.length) {
          employeeData.push({
            device: '',
            deviceType: '',
            deviceStatus: '',
            ...obj
          })
        } else {
          for (const device of devices) {
            employeeData.push({
              device: device.name || '',
              deviceType: device.o365TenantUser ? 'Microsoft Teams User' : (device.phone ? 'Phone' : 'Computer'),
              deviceStatus: device.disabled ? 'Disabled' : 'Enabled',
              ...obj
            })
          }
        }
      }
      
      const cols = [
        {label: 'Employee', value: 'employee'},
        {label: 'Employee Number', value: 'employeeNumber'},
        {label: 'Employee Status', value: 'employeeStatus'},
        {label: 'Team', value: 'team'},
        {label: 'Device', value: 'device'},
        {label: 'Device Type', value: 'deviceType'},
        {label: 'Device Status', value: 'deviceStatus'},
      ]
      
      let data = [{
        sheet: 'Employees',
        columns: cols,
        content: employeeData
      }]
      
      let settings = {
        fileName: 'Employee Export',
      }
      
      xls(data, settings)
    }
  },
  computed: {

  },
}
</script>

<style scoped>

</style>